import React from 'react';
import { Box, Button, Container, Chip, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import Typo from './Typo';
import { useTranslation } from 'react-i18next';
const CallToAction = ({
  title,
  description,
  primaryButtonText,
  primaryButtonLink,
  secondaryButtonText,
  secondaryButtonLink,
}) => {

  const navigate = useNavigate();
  const { t } = useTranslation();

  const handlePrimaryClick = () => {
    navigate('/meet-chekup');
  };

  const handleSecondaryClick = () => {
    navigate('/use-cases');
  };

  return (
    <Container
      maxWidth={false}
      sx={{
        maxWidth: '1440px',
        px: { xs: 2, md: 4 },
        mt: 10,
        mb: 10,
      }}
    >
      <Box sx={{ px: { xs: 5, md: 0 } }}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 4, md: 6 },
            borderRadius: '16px',
            background: 'linear-gradient(135deg, #fff8f8 0%, #fff 100%)',
            boxShadow: '0px 8px 20px rgba(188, 12, 12, 0.08)',
            border: '1px solid #f0e0e0',
          }}
        >
          <Box
            sx={{
              position: 'relative',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
            }}
          >
            <Box sx={{ maxWidth: { xs: '100%', md: '60%' } }}>
              <Chip
                label="Démarrez aujourd'hui"
                size="small"
                sx={{
                  bgcolor: 'rgba(188, 12, 12, 0.1)',
                  color: '#bc0c0c',
                  mb: 2,
                  border: 'none',
                }}
              />

              <Typo
                variant="h2"
                text={title || "Prêt à transformer votre atelier d'automobile?"}
                sx={{
                  mb: 3,
                }}
              />

              <Typo
                variant="body1"
                text={
                  description ||
                  "Planifiez une démo personnalisée aujourd'hui et découvrez comment Chekup peut simplifier vos opérations, vous faire gagner du temps et augmenter vos profits."
                }
                sx={{
                  mb: 4,
                  maxWidth: 600,
                }}
              />

              <Box
                sx={{
                  display: 'flex',
                  flexDirection: { xs: 'column', sm: 'row' },
                  gap: 2,
                }}
              >
                <Button
                  variant="contained"
                  onClick={handlePrimaryClick}
                  sx={{
                    bgcolor: '#bc0c0c',
                    borderRadius: '8px',
                    textTransform: 'none',
                    py: 1.4,
                    px: 3.5,
                    boxShadow: '0px 4px 10px rgba(188, 12, 12, 0.2)',
                    '&:hover': {
                      bgcolor: '#a00a0a',
                      boxShadow: '0px 6px 12px rgba(188, 12, 12, 0.25)',
                    },
                  }}
                >
                  {t('primaryButtonText')}
                </Button>

                {secondaryButtonText && (
                  <Button
                    variant="outlined"
                    onClick={
                      handleSecondaryClick
                    }
                    sx={{
                      borderRadius: '8px',
                      textTransform: 'none',
                      py: 1.4,
                      px: 3.5,
                      borderColor: '#bc0c0c',
                      color: '#bc0c0c',
                      '&:hover': {
                        borderColor: '#a00a0a',
                        bgcolor: 'rgba(188, 12, 12, 0.04)',
                      },
                    }}
                  >
                    {t('membership')}
                  </Button>
                )}
              </Box>
            </Box>

            <Box
              sx={{
                display: { xs: 'none', md: 'flex' },
                justifyContent: 'flex-end',
                alignItems: 'center',
                flex: 1,
                position: 'relative',
              }}
            >
              <Box
                component="img"
                src="/assets/chekup/ctaVisual.svg"
                alt="CHEK UP sur différents appareils"
                sx={{
                  width: 500,
                  height: 'auto',
                  opacity: 0.95,
                  transform: 'scale(1.05)',
                  filter: 'drop-shadow(0px 8px 15px rgba(0, 0, 0, 0.15))',
                  position: 'relative',
                  zIndex: 1,
                }}
              />
              {/* <Box
              sx={{
                position: 'absolute',
                width: '400px',
                height: '400px',
                borderRadius: '50%',
                background:
                  'radial-gradient(circle, rgba(188,12,12,0.15) 0%, rgba(188,12,12,0.05) 50%, rgba(255,255,255,0) 80%)',
                zIndex: 0,
              }}
            /> */}
            </Box>
          </Box>
        </Paper>
      </Box>
    </Container>
  );
};

export default CallToAction;
